<template>
	<div class="control">
		<multiselect
			v-model="selected"
			label="title"
			track-by="id"
			:class="{ error: error }"
			:placeholder="placeholder"
			:options="facilities"
			:searchable="true"
			:internal-search="false"
			:loading="isFetching"
			:options-limit="20"
			:clear-on-select="false"
			:limit="3"
			:max-height="200"
			:show-no-results="false"
			@search-change="listingFind"
			@remove="removed"
		>
		</multiselect>
	</div>
</template>

<script>
import { facilitySearch } from "@lab/api/";
import Multiselect from "vue-multiselect";

export default {
	name: "FieldListingSelect",
	components: { Multiselect },
	props: {
		prePopulated: {
			type: Array,
			default: () => []
		},
		placeholder: {
			type: String,
			default: () => "Select from shortlist or search for a facility"
		},
		preSelect: {
			type: Number,
			default: () => null
		},
		error: {
			type: Boolean,
			default: () => false
		}
	},
	data() {
		return {
			isFetching: false,
			options: [],
			selected: null
		};
	},
	computed: {
		facilities() {
			if (this.options.length) {
				return this.options;
			}
			return this.prePopulated;
		}
	},
	watch: {
		selected(data) {
			this.$emit("change", data);
		},
		preSelect(value) {
			this.selected = value;
		}
	},
	created() {
		if (this.preSelect) {
			this.selected = this.preSelect;
		}
	},
	beforeMount() {
		this.options = [];
	},
	methods: {
		listingFind(query) {
			this.isFetching = true;
			if (query.length >= 3) {
				facilitySearch(query).then((response) => {
					this.options = response;
					this.isFetching = false;
				});
			} else {
				this.isFetching = false;
			}
		},
		removed(listing) {
			if (listing) {
				this.options = [];
			}
		}
	}
};
</script>

<style lang="scss">
@import "~vue-multiselect/dist/vue-multiselect.min.css";
.multiselect.error {
	.multiselect__tags {
		border: 1px solid red;
	}
}
</style>
